export const promptsData = [
  {
    id: 1,
    category: "Coding & Tech",
    title: "The Perfect Bug Hunter",
    description: "Forces the LLM to review your code as an expert software architect.",
    prompt: "You are an elite Staff Software Engineer. Review the following code snippet. Identify any logical bugs, edge cases, potential security vulnerabilities, or performance bottlenecks. Provide optimized alternative code.\n\n[PASTE YOUR CODE HERE]"
  },
  {
    id: 2,
    category: "Writing & SEO",
    title: "Viral Hook Generator",
    description: "Creates 5 high-converting hooks for any blog or social media post.",
    prompt: "Act as a viral copywriting expert. I am providing a topic below. Give me 5 highly engaging opening hooks that trigger curiosity or address an immediate pain point. Keep them under 20 words each.\n\nTopic: [YOUR TOPIC]"
  },
  {
    id: 3,
    category: "Design & UI/UX",
    title: "Comprehensive Style Guide",
    description: "Asks Midjourney or DALL-E to construct unified visual assets.",
    prompt: "Create a modern, clean design system illustration. 3D isometric style, vibrant gradient overlay of indigo and violet, high resolution, minimalist aesthetic, suitable for tech landing page headers."
  },
  {
    id: 4,
    category: "Business Strategy",
    title: "Lean Startup Canvas",
    description: "Generates a fully fleshed out business plan framework in under 2 minutes.",
    prompt: "Construct a complete Lean Startup Canvas for a digital SaaS idea. Map out the Problem, Solution, Unique Value Proposition, Unfair Advantage, Customer Segments, Key Metrics, Channels, Cost Structure, and Revenue Streams."
  },
  {
    id: 5,
    category: "Productivity",
    title: "The Ultimate Summarizer",
    description: "Condenses huge blocks of text into actionable execution logs.",
    prompt: "Read the following text block carefully. Extract the top 5 key takeaways as concise bullet points, followed by a list of immediately actionable next steps with defined priorities. Text:\n\n[PASTE YOUR TEXT HERE]"
  }
];
